import React from 'react';

const packages = [
  {
    name: 'M.U.S.T. Package',
    services: ['Signature Massage', 'Hydrating Facial', 'Aromatherapy Retreat'],
    price: '$320',
    audience: 'Perfect for individuals seeking a full-body and facial renewal.',
  },
  {
    name: "Couple's Retreat",
    services: ["Couple's Massage", 'Hot Stone Therapy', 'Scalp Massage'],
    price: '$260',
    audience: 'Designed for couples to relax and reconnect together.',
  },
  {
    name: 'Detox & Glow',
    services: ['Deep Tissue Massage', 'Anti-Aging Facial', 'Cupping'],
    price: '$290',
    audience: 'Ideal for those wanting to detoxify and rejuvenate their skin.',
  },
  {
    name: 'Serenity Escape',
    services: ['Swedish Massage', 'Aromatherapy Retreat', 'CBD Oil Add-on'],
    price: '$250',
    audience: 'A calming escape for anyone needing deep relaxation.',
  },
];

function Packages() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8F6F2] via-[#E8F5F2] to-[#F9E9E9] font-sans pb-16">
      <section className="container mx-auto py-16 px-4 md:px-0">
        <h1 className="text-4xl md:text-5xl font-bold text-center text-[#222] mb-8 font-serif">Spa Packages</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10">
          {packages.map((pkg, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-md p-8 flex flex-col items-center text-center hover:shadow-xl transition">
              <h2 className="text-2xl font-bold text-[#B2D8C5] mb-2 font-serif">{pkg.name}</h2>
              <ul className="mb-4 text-[#6B7280]">
                {pkg.services.map((service, i) => (
                  <li key={i} className="mb-1">• {service}</li>
                ))}
              </ul>
              <div className="text-lg font-bold text-[#222] mb-2">{pkg.price}</div>
              <div className="text-sm text-[#6B7280] mb-4">{pkg.audience}</div>
              <button className="bg-[#B2D8C5] text-white px-6 py-2 rounded-full font-semibold shadow hover:bg-[#F7CAC9] transition">Book</button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Packages; 